import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h3","key":"svg-2"}],["path",{"d":"M19 16v6","key":"svg-3"}],["path",{"d":"M19 22l3 -3","key":"svg-4"}],["path",{"d":"M19 22l-3 -3","key":"svg-5"}]]

const IconFilter2Down = createReactComponent('outline', 'filter-2-down', 'Filter2Down', __iconNode);

export default IconFilter2Down;